<template>
    <div class="header">
      <img src="@/assets/headerDesafio.png" />
    </div>
<div class="contenedor fondo text-center">
    <div class="row mx-auto col-sm-12 desktop">
        <div>
            <img src="@/assets/mesAbril.png" alt="" style="width:100%">
        </div>
        <div>
            <p class="grayText">Promoción válida exclusivamente para clientes Enjoy Club que hayan alcanzado las categorías Platinum, Diamond y Seven Stars antes del 19 de Julio de 2023. Inscripciones desde el 24/7/23 al 15/08/23. Acumulación: 1 punto cada CLP$1.000 en máquinas de azar o CLP$3.000 en mesas. Plazo para cumplir la meta, desde el 01/08/2023 hasta el 31/08/23. Los premios se cargarán al martes siguiente de la fecha del cumplimiento de la meta, el plazo para utilizar el premio es de 30 días.</p>
        </div>
    </div>

</div>
</template>

<script>
export default {
   created(){
      window.scrollTo(0,0);
    }
}
</script>
